<template>
  <div>
    <label class="slds-form-element__label">
      {{ $t('campaignDesigner.targetDefinition.brand') }}<abbr class="slds-required" title="required" v-if="mode === 'edit' || mode === 'create'">*</abbr>
    </label>
    <div class="slds-form-element__control row">
      <div :class="{'has-error' : !valid}">
        <img :src="getIconName(brand.logo)" :class="getClass(brand.value)" v-for="brand in brands" :key="brand.value" @click="toggleBrandSelection(brand.value)" />
      </div>
    </div>
    <div class="slds-form-element__help error" v-if="!valid">{{ error }}</div>
  </div>
</template>
<script>
import Validator from '../../../../validation/Validator'
export default {
  mixins: [Validator],
  data () {
    return {
      localValue: []
    }
  },
  methods: {
    toggleBrandSelection (brand) {
      if (this.mode !== 'view') {
        const index = this.localValue.indexOf(brand)
        if (index >= 0) {
          this.localValue.splice(index, 1)
        } else {
          this.localValue.push(brand)
        }

        this.$emit('input', this.localValue)
      }
    },
    getIconName (iconName) {
      return require(`../../../../assets/icons/brand-logo/${iconName}`).default
    },
    getClass (brand) {
      return {
        'brand-logo-edit': this.mode === 'edit' || this.mode === 'create',
        'brand-logo-view': this.mode === 'view',
        'selected': this.localValue.includes(brand)
      }
    }
  },
  props: {
    brands: Array,
    mode: String,
    value: Array
  },
  created () {
    this.localValue = this.value
  },
  watch: {
    value (value) {
      this.clearValidationError()
      this.localValue = value
    }
  }
}
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.brand-logo-edit {
  margin-right: 5px;
  height: 32px;
  opacity: 0.5;
  cursor: pointer;

  &.selected {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
    cursor: pointer;
  }
}

.brand-logo-view {
  margin-right: 5px;
  height: 32px;
  opacity: 0.5;

  &.selected {
    opacity: 1;
  }
}

.has-error {
    border: 1px solid #C23934;
    border-radius: 0.25rem;
}

.error {
  color: #C23934;
}
</style>
